import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewPromotionpageNews from "../../components/Promotion/ViewPromotionLayer";



const ViewPromotion= () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View Promotion" title2="Promotion" link2="/promotion" />

        {/* AddUserLayer */}
        <ViewPromotionpageNews />


      </MasterLayout>
    </>
  );
};

export default ViewPromotion;
